module.exports = __webpack_public_path__ + "img/SEND.14a3d91f.svg";